import type { ActiveStudySite, AuthUser } from 'common/auth/types';
import { AuditCreationEventsEnum, AuditEntityIdEnum } from 'common/log/auditevents';
import { CIAuditLogger } from 'common/log/ci.auditlogger';
import { CILogger } from 'common/log/log.provider';
import { getStudyIdWithoutVersion } from 'common/utils/common.utils';

import type { DeviceHandoffRejectionReason } from '../state/types';

function studyAndSiteId(activeStudySite: ActiveStudySite): { studyId?: string; siteId?: string } {
    return {
        studyId: getStudyIdWithoutVersion(activeStudySite.activeStudy?.studyId),
        siteId: activeStudySite.activeSite?.siteId,
    };
}

export function auditLogRespondentTookControl(respondent: AuthUser, activeStudySite: ActiveStudySite): void {
    const { studyId, siteId } = studyAndSiteId(activeStudySite);

    CIAuditLogger.getInstance().log(
        AuditCreationEventsEnum.Access,
        `Respondent ${respondent.username} took control of the device by switch user`,
        null,
        {
            relatedEntityName: AuditEntityIdEnum.User,
            relatedEntityId: respondent.username,
            studyId,
            siteId,
            subjectId: respondent.pk,
        }
    );
    CILogger.getInstance().info(`device handoff: respondent ${respondent.pk} took control of the device`);
}

export function auditLogSiteUserResumed(siteUser: AuthUser): void {
    CIAuditLogger.getInstance().log(
        AuditCreationEventsEnum.Access,
        `Site user ${siteUser.username} resumed control of the device after switch user`,
        null,
        { relatedEntityName: AuditEntityIdEnum.User, relatedEntityId: siteUser.pk }
    );
    CILogger.getInstance().info(`device handoff: site user ${siteUser.pk} resumed control of the device`);
}

export function logHandoffRejected(rejectedUser: AuthUser, reason: DeviceHandoffRejectionReason): void {
    CILogger.getInstance().info(`device handoff: rejected candidate ${rejectedUser.pk} (${reason})`);
}
